"use client";

import Grid from "@mui/material/Grid2";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useFormikContext } from "formik";

import CurrencyInput from "@/components/atoms/CurrencyInput";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { SkuFormData } from "@/components/screens/ProductFormPage/types";
import { SkuFormMessages } from "@/messages/sku/sku-form.messages";

type Props = {
  messages: SkuFormMessages;
};

function Pricing({ messages }: Props) {
  const { values, handleChange, errors, setFieldValue } = useFormikContext<SkuFormData>();

  return (
    <MDBox p={3}>
      <MDBox display="flex" justifyContent="space-between">
        <MDTypography variant="h5" fontWeight={"bold"}>
          {messages.pricingTitle}
        </MDTypography>
      </MDBox>

      <MDBox mt={1}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <CurrencyInput
              name="mainPrice"
              label={messages.mainPriceLabel}
              value={values.mainPrice}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              error={!!errors.mainPrice}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <DatePicker
              label={messages.promotionStartLabel}
              value={dayjs(values.startPromoPrice)}
              onChange={(value) => setFieldValue("startPromoPrice", value)}
              slotProps={{
                textField: {
                  error: !!errors.startPromoPrice,
                  fullWidth: true,
                  variant: "standard",
                  InputLabelProps: { shrink: true },
                },
              }}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <DatePicker
              label={messages.promotionEndLabel}
              value={dayjs(values.endPromoPrice)}
              onChange={(value) => setFieldValue("endPromoPrice", value)}
              slotProps={{
                textField: {
                  error: !!errors.endPromoPrice,
                  fullWidth: true,
                  variant: "standard",
                  InputLabelProps: { shrink: true },
                },
              }}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 6 }}>
            <CurrencyInput
              name="promoPrice"
              label={messages.promotionalPriceLabel}
              value={values.promoPrice}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
              error={!!errors.promoPrice}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default Pricing;
